import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import * as Constants from '../constants';
import EinsteinHeaderIcon from '../../static/img/einstein-header-icon.svg';

import './EinsteinRecommendation.scss';

export class EinsteinRecommendation extends Component {
  renderDescription() {
    const { formatMessage, formatNumber } = this.props.intl;
    const { einsteinFrequencyRecs, dataFilter } = this.props;
    const values = {
      frequencyRange: (
        <strong>
          {einsteinFrequencyRecs.undersaturated} -{' '}
          {einsteinFrequencyRecs.oversaturated}
        </strong>
      ),
      eventType: (
        <strong>
          {formatMessage({
            id: `EinsteinRecommendation.eventType.${dataFilter.eventType}`
          })}
        </strong>
      ),
      increaseRate: (
        <strong>
          {formatNumber(einsteinFrequencyRecs.expectedGain, {
            style: 'percent',
            maximumFractionDigits: 2
          })}
        </strong>
      ),
      frequencyDays: (
        <strong>
          {formatMessage(
            { id: `EinsteinRecommendation.frequencyDays` },
            { dayCount: dataFilter.lookback }
          )}
        </strong>
      )
    };
    const description =
      einsteinFrequencyRecs.status === Constants.RECOMMENDATION_STATUS.ok ? (
        <FormattedMessage
          id="EinsteinRecommendation.simpleDescription"
          values={values}
        />
      ) : (
        <FormattedMessage
          id={`EinsteinRecommendation.error.${einsteinFrequencyRecs.status}`}
        />
      );
    return description;
  }

  render() {
    return (
      <div className="einstein-recommendation">
        <div className="slds-card-content">
          <h3>
            <FormattedMessage id="EinsteinRecommendation.title" />
          </h3>
          <p>{this.renderDescription()}</p>
        </div>
        <img
          className="einstein-icon"
          src={EinsteinHeaderIcon}
          alt="Einstein"
        />
      </div>
    );
  }
}

EinsteinRecommendation.propTypes = {
  einsteinFrequencyRecs: PropTypes.object,
  dataFilter: PropTypes.object,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(EinsteinRecommendation);
